import { MouseEvent, useEffect, useState } from 'react'

import { DEFAULT_SELECTED_IMAGE_INDEX } from '../ui/image-gallery/image-list'

export const useCarousel = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(
    DEFAULT_SELECTED_IMAGE_INDEX,
  )

  const isGalleryOpen = selectedImageIndex !== DEFAULT_SELECTED_IMAGE_INDEX

  const handleClose = () => {
    document.body.classList.remove('fixed-body')
    document.documentElement.style.overflow = 'auto'
  }

  const handleThumbnailClick = (index: number) => {
    setSelectedImageIndex(index)
    document.body.classList.add('fixed-body')
    document.documentElement.style.overflow = 'hidden'
  }

  const handleGalleryClose = () => {
    setSelectedImageIndex(DEFAULT_SELECTED_IMAGE_INDEX)
    setTimeout(handleClose, 500)
  }

  const handleContextMenu = (event: MouseEvent<HTMLImageElement>) => {
    event.preventDefault()
  }

  useEffect(() => {
    return () => {
      handleClose()
    }
  }, [])

  return {
    selectedImageIndex,
    isGalleryOpen,
    handleClose,
    handleThumbnailClick,
    handleGalleryClose,
    handleContextMenu,
  }
}
